// extracted by mini-css-extract-plugin
export default {"label":"styles_label__nQHDv","autocomplete-margin":"styles_autocomplete-margin__2i1Zk"};